import * as React from 'react';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as MapModule from 'Modules/MapModule';
import {connect} from 'react-redux';
import {SVG, SVGEnum} from 'HelperFunctions/SVG';

type P = {
    small?: boolean;
};
type DispatchedProps = {
    manageZoom: (type: 'add' | 'substract') => void;
    smallMapmanageZoom: (type: 'add' | 'substract') => void;
};
type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

const ZoomManagement = (props: DispatchedProps & ConnectedProps & P) => {
    const {manageZoom, small, smallMapmanageZoom} = props;
    return (
        <div className="map-manage__zoom">
            <button onClick={() => (small ? smallMapmanageZoom('add') : manageZoom('add'))}
                    className={`map-manage__btn`}>
                <SVG type={SVGEnum.PLUS}/>
            </button>
            <button onClick={() => (small ? smallMapmanageZoom('substract') : manageZoom('substract'))}
                    className={`map-manage__btn`}>
                <SVG type={SVGEnum.MINUS}/>
            </button>
        </div>
    );
};

function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        manageZoom: (type: 'add' | 'substract') => dispatch(MapModule.Actions.manageZoom(type)),
        smallMapmanageZoom: (type: 'add' | 'substract') => dispatch(MapModule.Actions.smallMapmanageZoom(type))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(ZoomManagement) as React.ComponentClass<P>;



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/ZoomManagement.tsx